import { Image, useColorMode, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import logo from "../../assets/img/if.png";
import logo_dark from "../../assets/img/if_dark.png";

import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Link,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { doc, getDoc } from "firebase/firestore";
import { UserAuth } from "../../auth/AuthContext";

import { useEffect } from "react";
import { db } from "../../firebase-config";

function Login() {
  const { user } = UserAuth();

  const color1 = useColorModeValue("gray.50", "gray.800");
  const color2 = useColorModeValue("white", "gray.700");
  const navigate = useNavigate();
  const toast = useToast();

  const { colorMode } = useColorMode();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [sucesso, setSucesso] = useState("");
  const { loginHook, setUserRef } = UserAuth();
  const authToken = document.cookie
    .split("; ")
    .find((row) => row.startsWith("authToken="))
    ?.split("=")[1];
  useEffect(() => {
    if (user && authToken) {
      navigate("/", { replace: true });
    }
  }, [user & authToken]);

  const LoginUser = async (e) => {
    if (!email || !password) {
      setMensagem("Informe todos os campos!");
      return;
    }
    setSucesso("S");

    try {
      const userCredential = await loginHook(email, password);
      const token = await userCredential.user.getIdToken();
      // localStorage.setItem("authToken", token);
      // sessionStorage.setItem("user", JSON.stringify(providerData));
      const userDoc = doc(db, "/users", userCredential.user.uid);
      const docSnap = await getDoc(userDoc);
      document.cookie = `authToken=${token}; max-age=50400; path=/;`;

      if (docSnap.exists()) {
        setUserRef(docSnap.data());
      } else {
        // doc.data() will be undefined in this case
        // console.log("No such document!");
      }

      setMensagem("");
      ToastLogado();
      navigate("/", { replace: true });
    } catch (e) {
      setSucesso("N");
      toast({
        title: "E-mail ou senha inválidos. Verifique-os!",
        status: "error",
        duration: 5000,
        isClosable: false,
      });
      setMensagem(``);
      console.log(e.message);
    }
  };

  const ToastLogado = () => {
    return toast({
      title: `Logado com sucesso!`,
      position: "bottom",
      status: "success",
      variant: "top-accent",
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <div>
      <Flex minH={"100vh"} align={"center"} justify={"center"} bg={color1}>
        <Stack spacing={8} mx={"auto"} maxW={"lg"} py={0} mt={-20} px={5}>
          <Stack align={"center"}>
            <Image
              width={"200px"}
              objectFit="cover"
              src={colorMode === "light" ? logo_dark : logo}
              alt="Light Logo"
            />
            <Heading fontSize={"4xl"}>Entre com a sua conta</Heading>
            <Text fontSize={"lg"} color={"gray.400"}>
              nunca compartilhe a sua senha, ela é{" "}
              <Link color={"blue.400"}>secreta</Link> 🔒
            </Text>
          </Stack>
          <Box rounded={"lg"} bg={color2} boxShadow={"lg"} p={8}>
            <Stack spacing={4}>
              <FormControl id="email" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      LoginUser();
                    }
                  }}
                />
              </FormControl>
              <FormControl id="password" isRequired>
                <FormLabel>Senha</FormLabel>
                <Input
                  type="password"
                  placeholder="Senha"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      LoginUser();
                    }
                  }}
                />
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: "column", sm: "row" }}
                  align={"start"}
                  justify={"space-between"}
                >
                  <Checkbox isChecked>Manter sessão</Checkbox>
                  <Link color={"blue.400"}>Esqueci a senha</Link>
                </Stack>

                {sucesso === "S" ? (
                  <Button
                    isLoading
                    loadingText="Autenticando..."
                    colorScheme="green"
                    variant="outline"
                  ></Button>
                ) : (
                  <Button
                    bg={"blue.400"}
                    color={"white"}
                    _hover={{
                      bg: "blue.500",
                    }}
                    type="button"
                    onClick={LoginUser}
                  >
                    Entrar
                  </Button>
                )}

                {mensagem.length > 0 ? (
                  <Alert status="error">
                    <AlertIcon />
                    {mensagem}
                  </Alert>
                ) : null}
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    </div>
  );
}

export default Login;
